import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { observe } from '@web/util/loading/loading';
import { locale } from '@util/locale';
import {
  AdditionalQuestionsService,
  ReservationAdditionalQuestionAnswer,
} from '@services/dws/additional-questions.service';

@Component({
  selector: 'web-additional-questions-popup',
  templateUrl: './additional-questions-popup.component.html',
  styleUrls: ['./additional-questions-popup.component.scss'],
})
export class AdditionalQuestionsPopupComponent implements OnInit {
  answers: ReservationAdditionalQuestionAnswer[] = [];
  loading = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { reservationId: string },
    private dialogRef: MatDialogRef<AdditionalQuestionsPopupComponent>,
    private additionalQuestionsService: AdditionalQuestionsService
  ) {}

  ngOnInit(): void {
    observe(
      this.additionalQuestionsService.listReservationAnswers(this.data.reservationId)
    ).subscribe(
      (items) => {
        this.answers = items || [];
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }

  closeClicked(): void {
    this.dialogRef.close();
  }

  questionText(answer: ReservationAdditionalQuestionAnswer): string {
    const lang = (locale().locale || 'en').toLowerCase();
    const snap = answer.questionTextSnapshot || {};
    return snap[lang] || snap['en'] || snap['it'] || Object.values(snap)[0] || '';
  }

  answerLabels(answer: ReservationAdditionalQuestionAnswer): string[] {
    const snap = answer.answerSnapshot || {};
    const labels = (snap['displayLabels'] ?? snap['labels']) as string[] | undefined;
    if (!labels?.length) {
      return [];
    }
    return labels
      .filter((label) => label != null && String(label).trim())
      .map((label) => String(label).trim());
  }

  isMultipleChoiceAnswer(answer: ReservationAdditionalQuestionAnswer): boolean {
    return answer.answerType === 'multiple_choice' && this.answerLabels(answer).length > 0;
  }

  answerText(answer: ReservationAdditionalQuestionAnswer): string {
    const snap = answer.answerSnapshot || {};
    const displayText = snap['displayText'];
    if (displayText != null && String(displayText).trim()) {
      return String(displayText).trim();
    }
    const freeText = snap['freeText'] ?? snap['text'];
    if (freeText != null && String(freeText).trim()) {
      return String(freeText).trim();
    }
    const labels = this.answerLabels(answer);
    if (labels.length) {
      return labels.join(', ');
    }
    return '';
  }
}
